// 

import React from 'react';
import QuizGame from './components/QuizGame';

function App() {
  return (
    <div className="min-h-screen bg-gradient-to-r from-[#Fd688e] to-[#ff8ca8] w-full">
      <div className="container mx-auto px-4 py-8">
        <QuizGame />
      </div>
    </div>
  );
}

export default App;
